import { DispositionCode } from "../../models/enums/DispositionCode";
import { StoreState } from "../../models/states/StoreState";
import { navigationQuit } from "../actions";
import { ThunkActionType } from "../actions/types";

export const exitSurvey = (): ThunkActionType<void> => {
    const selectRespondentDispositionCode = (state: StoreState) =>
        state.interview.respondent.dispositionCode;

    return (dispatch, getState) => {
        let dispositionCode = selectRespondentDispositionCode(getState());
        if (dispositionCode !== DispositionCode.Completed) {
            dispositionCode = DispositionCode.Interrupted;
        }
        dispatch(navigationQuit(dispositionCode, { forcedQuit: true }));
    };
};
